import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";


// Capture beforeinstallprompt globally so it's never missed
window.__pwaInstallPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
